var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopmentTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95.14 54.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7da2fe;stroke-width:2px;}.cls-2,.cls-3{stroke-linejoin:round;}.cls-2,.cls-3,.cls-4{stroke:#fff;stroke-linecap:round;}.cls-3{stroke-width:1.21px;}.cls-3,.cls-4{fill:none;}.cls-5{fill:url(#linear-gradient);}.cls-4{stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 47.69,
    y1: 27.18,
    x2: 88.22,
    y2: 27.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.22,27.18c0,11.19-9.07,20.27-20.26,20.27s-20.27-9.08-20.27-20.27S56.77,6.92,67.96,6.92s20.26,9.07,20.26,20.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.96,1c-14.46,0-26.18,11.72-26.18,26.18s11.72,26.18,26.18,26.18,26.18-11.72,26.18-26.18S82.42,1,67.96,1Zm0,46.45c-11.19,0-20.27-9.08-20.27-20.27S56.77,6.92,67.96,6.92s20.26,9.07,20.26,20.27-9.07,20.27-20.26,20.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.94,
    y1: 46.3,
    x2: 67.94,
    y2: 41.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.38,
    y1: 43.73,
    x2: 60.77,
    y2: 39.61
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.39,
    y1: 36.72,
    x2: 55.52,
    y2: 34.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 48.84,
    y1: 27.16,
    x2: 53.61,
    y2: 27.17
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.41,
    y1: 17.61,
    x2: 55.54,
    y2: 19.99
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 58.42,
    y1: 10.62,
    x2: 60.79,
    y2: 14.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.98,
    y1: 8.07,
    x2: 67.97,
    y2: 12.83
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.53,
    y1: 10.64,
    x2: 75.15,
    y2: 14.76
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 84.52,
    y1: 17.64,
    x2: 80.39,
    y2: 20.02
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 87.07,
    y1: 27.2,
    x2: 82.31,
    y2: 27.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 84.5,
    y1: 36.76,
    x2: 80.38,
    y2: 34.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.5,
    y1: 43.75,
    x2: 75.12,
    y2: 39.62
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.12,26.27c-.49,.49-.49,1.27,0,1.76h0c.49,.49,1.27,.49,1.76,0l7.11-8.44c.23-.29-.15-.66-.44-.44l-8.44,7.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38.36,
    y1: 10.97,
    x2: 20.46,
    y2: 10.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38.36,
    y1: 43.39,
    x2: 20.46,
    y2: 43.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 34.92,
    y1: 19.08,
    x2: 9.36,
    y2: 19.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 34.92,
    y1: 35.29,
    x2: 9.36,
    y2: 35.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 31,
    y1: 27.18,
    x2: 2,
    y2: 27.18
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.21,27.17c0,.67-.55,1.22-1.22,1.22s-1.22-.55-1.22-1.22l.03-.28,.87-7.5c0-.17,.14-.31,.32-.31s.31,.14,.31,.31l.87,7.49,.02,.16s.01,.07,.01,.12Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentTime);
export default __webpack_public_path__ + "static/media/development-time.9981ce567758c9dbd2f90f6b91a8eb34.svg";
export { ForwardRef as ReactComponent };